import { mountPromotionStorefront } from './lf-promotion-storefront.js';

const bootstrapKey = Symbol.for('lf-promotion-bootstrap');
if (!window[bootstrapKey]) {
  window[bootstrapKey] = true;
  try {
    const script = document.querySelector('[data-lf-promotion-bootstrap]');
    const response = await fetch(script.dataset.configUrl, { credentials: 'omit', cache: 'no-store' });
    if (!response.ok) throw new Error('unavailable');
    const config = await response.json();
    const messages = JSON.parse(document.querySelector('[data-lf-promotion-messages]').textContent);
    mountPromotionStorefront({ config, messages });
  } catch {
    for (const element of document.querySelectorAll('[data-lf-promotion]')) element.hidden = true;
  }
}
